import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../include/api';
import { ERROR, SUCCESS } from '../../include/constant';
import { preventClick } from '../../include/function';
import { useNotification } from '../../Toast/ToastProvider';

const SuperLogin = ({ handleSuperAdmin }) => {
    const toast = useNotification();

    // States
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [otpInput, setOtpInput] = useState('');
    const [otpError, setOtpError] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [postLoading, setPostLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [currentView, setCurrentView] = useState('login');
    const handlePasswordChange = val => {
        setPasswordError('');
        setPassword(val);
    };

    const clearFields = () => {
        setPassword('');
        setPasswordError('');
    };

    const handleShowPassword = () => setShowPassword(!showPassword);

    const handleSignIn = () => {
        let error = false;
        const data = {
            email: String(email).trim().toLowerCase(),
            password,
        };

        if (!data.email) {
            setEmailError('Enter your e-mail');
            error = true;
        }
        if (!data.password) {
            setPasswordError('Enter your password');
            error = true;
        }

        if (!error) {
            setPostLoading(true);
            api.post('/super/', data)
                .then(response => {
                    if (response.status === 200) {
                        clearFields();
                        const user = response.data.data.user;
                        const token = response.data.data.token;
                        handleSuperAdmin(user, token);
                        toast({ type: SUCCESS, message: response.data.message });
                    }
                })
                .catch(error => {
                    error.response
                        ? toast({ type: ERROR, message: error.response.data.message })
                        : toast({ type: ERROR, message: error.message });
                })
                .finally(() => {
                    setPostLoading(false);
                });
        }
    };

    return (
        <div className="vh-100 d-flex justify-content-center align-items-center bg-primary">
            <div className="card p-4 shadow" style={{ maxWidth: '400px', width: '100%' }}>
                <div className="container">
                    <h2 className="text-center">Super Admin Login</h2>
                    <p className="text-50 text-center">Sign in to continue</p>

                    {/* Login Form */}
                    {currentView === 'login' && (
                        <form className="mt-4" action="#">
                            <div className="form-group mb-4">
                                <label>Email Id</label>
                                <input
                                    type="email"
                                    className={`form-control ${emailError ? 'border-danger' : ''}`}
                                    placeholder="Enter Your Email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                <div className="text-danger small">{emailError}</div>
                            </div>
                            <div className="form-group mb-4">
                                <div className="d-flex justify-content-between">
                                    <label>Password</label>
                                    <Link to="#" onClick={e => preventClick(e, handleShowPassword)}>
                                        {showPassword ? 'Hide' : 'Show'} Password
                                    </Link>
                                </div>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className={`form-control ${passwordError ? 'border-danger' : ''}`}
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={e => handlePasswordChange(e.target.value)}
                                />
                                <div className="text-danger small">{passwordError}</div>
                            </div>
                            <button
                                className="btn btn-primary w-100"
                                onClick={e => preventClick(e, handleSignIn)}
                                disabled={postLoading}
                            >
                                {postLoading ? 'Please wait...' : 'SIGN IN'}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SuperLogin;
